import store from 'store'
import Vue from 'vue'

const hasPermissionDirective = {
  inserted: function (el, binding, vnode) {
    let permission = binding.value
    if (typeof permission !== 'string') {
      try {
        throw new Error('数据类型必须是String')
      } catch (e) {
        console.error(e)
      }
    }
    if (!hasPermission(permission)) {
      el.parentElement.removeChild(el)
    }
  }
}

// 编译
function compile (permission) {
  let result = permission.trim().split(':')
  const name = result[0].trim()
  const operations = result[1].split(',').map((operation) => {
    return operation.trim()
  })
  return {[name]: operations}
}

function hasPermission (permission) {
  permission = compile(permission)
  let state = false
  const resource = store.getters.resource
  state = Object.keys(permission).every((key) => {
    return permission[key].every((operation) => {
      if (resource[key] && resource[key][operation]) {
        return true
      }
    })
  })
  return state
}

Vue.directive('has', hasPermissionDirective)

export default hasPermission



// WEBPACK FOOTER //
// ./src/directive/has-permission.js